import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type Form, type FormsState, type FormsActionTypes } from 'app/store/types';

const initialState: FormsState = {};

const formsReducer = (state = initialState, action: FormsActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { forms },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(forms && { byId: forms }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

// reducer
// const selectedFormReducer = (state: { [licenseGroupId: string]: Form } = {}, action: any) => {
// 	switch (action.type) {
// 		case GET_SELECTED_FORM_SUCCESS:
// 			return {
// 				...state,
// 				[action.payload.licenseGroupId]: action.payload.form
// 			};
// 		// ... other cases ...
// 		default:
// 			return state;
// 	}
// };

export default persistReducer(
	{
		key: 'forms',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	formsReducer,
);

// Selectors
export const getFormsById = ({ app: { selectedLicenseGroupId }, forms }: RootState) =>
	forms[selectedLicenseGroupId].byId;

export const getForms = createSelector([getFormsById], (FormsById) => Object.values(FormsById));

export const getFormById = (formId: Form['id']) => (state: RootState) => getFormsById(state)[formId];
